import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { PortalServiceMenuItemDto } from '@nx-frontend/shared/types';

export interface GetMenuItemsPayload {
  portalId: string;
}

export async function fetchMenuItems(payload: GetMenuItemsPayload): Promise<PortalServiceMenuItemDto[]> {
  try {
    const response = await axiosClient.get(`${generalEnv.nextCommonApiUrl}/portal/menu`, {
      params: payload,
      withCredentials: true,
    });
    return response.data;
  } catch (err) {
    console.error('Error in getMenuItems:', err);
    throw new Error('Internal error');
  }
}
